import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useRef } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import styles from './index.module.scss';

import actions from '@/actions';
import MissionTable from '@/components/ui/MissionTable';
import { NotifierService as notifier } from '@/libs/Notifier';

const cx = classNames.bind(styles);

const MissionBrowser = ({ active, onDone }) => {
  const store = useStore();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const missionTableRef = useRef();
  const selectedMissionId = useRef();
  const originMission = useRef();
  const isLoadingMission = useRef(false);

  useUpdateEffect(() => {
    // 미션 브라우저 오픈 시
    if (active) {
      missionTableRef.current.load();
      // 현재 미션 보관
      originMission.current = { ...store.getState().mission };

      dispatch(actions.mission.reset());
    }
    // 미션 브라우저 닫기 시
    else {
      missionTableRef.current.clearSelection();
      selectedMissionId.current = null;

      // Load 버튼이 아닌 Cancel 버튼으로 닫힌 경우 보관된 미션 복원
      if (!isLoadingMission.current) {
        dispatch(actions.mission.load(originMission.current));
      }

      originMission.current = null;
      isLoadingMission.current = false;
    }

    dispatch(actions.editor.setEnabled(!active));
  }, [active]);

  const handleSelect = (mission) => {
    // 미션 선택 해제된 경우 (예: 미션 삭제)
    if (!mission) {
      dispatch(actions.mission.reset());
      selectedMissionId.current = null;
      return;
    }

    selectedMissionId.current = mission.id;
    dispatch(actions.mission.load(mission));
  };

  const doLoad = () => {
    if (!selectedMissionId.current) {
      notifier.error('No item selected.');
      return;
    }
    if (selectedMissionId.current === originMission.current.id) {
      notifier.error('This mission is already loaded.');
      return;
    }

    isLoadingMission.current = true;
    onDone();
    navigate(`/mission-hub/${selectedMissionId.current}`, { replace: true });
  };

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>Missions</div>
      </div>
      <MissionTable ref={missionTableRef} onSelect={handleSelect} lazy showDelete className={cx('body')} />
      <div className={cx('bottom')}>
        <button type="button" className={cx('button')} onClick={onDone}>
          Cancel
        </button>
        <button type="button" className={cx(['button', 'accent'])} onClick={doLoad}>
          Load
        </button>
      </div>
    </div>
  );
};

export default MissionBrowser;
